/**
 * External dependencies
 */
import useSWR from "swr";

/**
 * Internal dependencies
 */
import { objectToUrlParams } from "../utils";
import { fetcher } from "./fetcher";

/**
 * Configuration
 */
import config from "../config";
const { ajax_url, actions } = config;

export function usePosts(filters, action = actions?.posts) {
	const requestParams = objectToUrlParams(filters);

	const { data, error } = useSWR([ajax_url, action, requestParams], fetcher);

	const isEmpty = data && data.length === 0;

	return {
		posts: data,
		postsError: error,
		isEmpty,
	};
}
